import React, { useState } from 'react';
// import { useNotify } from 'react-admin';
import { TextField, Tabs, Tab, Button, CircularProgress, Paper, Typography, IconButton, MenuItem } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import config from './config.json';
import { useHistory } from "react-router-dom";
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { stringify } from 'query-string';
import { CustomTextInput, CustomSwitch, CustomNumberInput } from './components/CustomInputFields';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import { saveTokens } from './utils/saveTokens';
import notify from './components/CustomUseNotify';
import JSONInput from 'react-json-editor-ajrm';
import locale from 'react-json-editor-ajrm/locale/en';

const templateJSON =  {
    "id": null,
    "device_id": "",
    "access_key_id": null,
    "action": "",
    "internal_ip": "",
    "description": "",
    "external_ip": "",
    "group_name": "",
    "unit_id": "",
    "notes": "",
    "parking_name": "",
    "settings": {
      "access_key": "",
      "base_api_url": "https://parksmart.co.in",
      "boom_barriers": [],
      "closed_loop_enabled": false,
      "database": "",
      "duplicate_readers": false,
      "duplicate_timeout": 0,
      "id": "",
      "is_anpr_enabled": false,
      "is_boom_barrier_led_enabled": false,
      "is_network_led_enabled": false,
      "is_program_led_enabled": false,
      "is_reader_led_enabled": false,
      "is_server_led_enabled": false,
      "open_even_if_duplicate": false,
      "readers": [],
      "slotting_enabled": false
    }
  }
  
const CATEGORY = "CREATE CONTROLLER SECTION"

const ControllerCreate = () => {
    const eventTracker = UseAnalyticsEvent()
    const navigate = useHistory()
    //const notify = useNotify()
    const [uploadLoader, setUploadLoader] = useState(false)
    const [controllerName, setControllerName] = useState("")
    const [accessKey, setAccessKey] = useState("")
    const [baseApiUrl, setbaseApiUrl] = useState("https://parksmart.co.in")
    const [ledPanelDev, setLedPanelDev] = useState("")
    const [deviceId, setDeviceId] = useState("")
    const [loopDays, setLoopDays] = useState("")
    const [loopDaysEnable, setLoopDaysEnable] = useState(false)
    const [slottingEnable, setSlottingEnable] = useState(false)
    const [ledPanelEnable, setLedPanelEnable] = useState(false)
    const [ledBoardEnable, setLedBoardEnable] = useState(false)
    const [ledBoardDev, setLedBoardDev] = useState("")
    const [ledBoardRows, setLedBoardRows] = useState("")
    const [ledPanelRows, setLedPanelRows] = useState("")
    const [boomBarriers, setBoomBarries] = useState([])
    const [readers, setReaders] = useState([])
    const [value, setValue] = useState("boom_barriers");
    const [action, setAction] = useState("BOTH");

    const [options, setOptions] = useState([]);
    const [autovalue, setAutoValue] = React.useState("");
    const [inputValue, setInputValue] = React.useState('');
    //const [loading, setLoading] = useState(false);

    const [dataBase, setDatabase] = useState("")
    const [fastagApiUrl, setFastagApiUrl] = useState("")
    const [fastagToken, setFastagToken] = useState("")
    const [fastagEnable, setFastagEnable] = useState(false)
    const [duplicateTimeout, setDuplicateTimeout] = useState("")
    const [anprId, setAnprId] = useState("")
    const [isAnprEnabled, setIsApnrEnabled] = useState(false)

    const [ledGpioOn, setLedGpioON] = useState(false)

    const [isNetworkLedEnabled, setIsNetworkLedEnabled] = useState(false)
    const [networkLedGpio, setNetworkLedGpio] = useState(16)

    const [isServerLedEnabled, setIsServerLedEnabled] = useState(false)
    const [serverLedGpio, setServerLedGpio] = useState(10)

    const [isReaderLedEnabled, setIsReaderLedEnabled] = useState(false)
    const [readerLedGpio, setReaderLedGpio] = useState(8)

    const [isProgramLedEnabled, setIsProgramLedEnabled] = useState(true)
    const [isBoomBarrierLedEnabled, setIsBoomBarrierLedEnabled] = useState(false)

    const [duplicateReaders, setDuplicateReaders] = useState(false)
    const [openEvenIfDuplicate, setOpenEvenIfDuplicate] = useState(false)
    const [integrateWithMyGate, setIntegrateWithMyGate] = React.useState('0');
    const [deviceType, setDeviceType] = React.useState('');

    const SETTING = "SETTING"
    const JSON_SETTING = "JSON_SETTING"
    const EDIT_SETTING = "EDIT_SETTING"
    const JSON_FILE = "JSON_FILE"
    const [currentTab, setCurrentTab] = React.useState(SETTING);
    const [settingEditorJson, setSettingEditorJson] = React.useState('');
    const [settingJson, setSettingJson] = React.useState(templateJSON.settings);

    const handleJsonChange = (newJson) => {
        // Update the state variable with the new JSON object
        setSettingJson(newJson.jsObject);
      };

    const actionHandler = (event) => {
        setAction(event.target.value);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const saveHandler = () => {

        setUploadLoader(true)
        // let settings = {
        //     access_key: accessKey,
        //     base_api_url: baseApiUrl,
        //     boom_barriers: boomBarriers,
        //     closed_loop_days: loopDays,
        //     closed_loop_enabled: loopDaysEnable,
        //     id: deviceId,
        //     led_board: { dev: ledBoardDev, enabled: ledBoardEnable, num_rows: ledBoardRows },
        //     led_panel: { dev: ledPanelDev, enabled: ledPanelEnable, num_rows: ledPanelRows },
        //     readers: readers,
        //     slotting_enabled: slottingEnable,
        //     database: dataBase,
        //     fastag_base_api_url: fastagApiUrl,
        //     fastag_token: fastagToken,
        //     fastag_payments_enabled: fastagEnable,
        //     duplicate_timeout: duplicateTimeout,
        //     anpr_ip: anprId,
        //     is_anpr_enabled: isAnprEnabled
        // }

        let settings = {
            access_key: accessKey,
            base_api_url: baseApiUrl,
            boom_barriers: boomBarriers,
            closed_loop_enabled: loopDaysEnable,
            id: deviceId,
            readers: readers,
            slotting_enabled: slottingEnable,
            database: dataBase,
            fastag_payments_enabled: fastagEnable,
            duplicate_timeout: duplicateTimeout,
            is_anpr_enabled: isAnprEnabled,
            led_gpio_on: ledGpioOn,
            is_network_led_enabled: isNetworkLedEnabled,
            is_boom_barrier_led_enabled: isBoomBarrierLedEnabled,
            is_server_led_enabled: isServerLedEnabled,
            is_reader_led_enabled: isReaderLedEnabled,
            is_program_led_enabled: isProgramLedEnabled,
            duplicate_readers: duplicateReaders,
            open_even_if_duplicate: openEvenIfDuplicate
        }

        if (loopDaysEnable) {
            settings.closed_loop_days = loopDays
        }
        if (ledPanelEnable) {
            settings.led_panel = { dev: ledPanelDev, enabled: ledPanelEnable, num_rows: ledPanelRows }
        }
        if (ledBoardEnable) {
            settings.led_board = { dev: ledBoardDev, enabled: ledBoardEnable, num_rows: ledBoardRows }
        }
        if (fastagEnable) {
            settings.fastag_token = fastagToken
            settings.fastag_base_api_url = fastagApiUrl
        }
        if (isAnprEnabled) {
            settings.anpr_id = anprId
        }
        if (isNetworkLedEnabled) {
            settings.network_led_gpio = networkLedGpio
        }
        if (isServerLedEnabled) {
            settings.server_led_gpio = serverLedGpio
        }
        if (isReaderLedEnabled) {
            settings.reader_led_gpio = readerLedGpio
        }

        fetch(`${config.HOST_NAME}/crm/v3/parkingControllers`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            },
            body: JSON.stringify({ device_id: deviceId, settings: settings, description: controllerName, action_type: action, integrate_with_my_gate: parseInt(integrateWithMyGate), device_type: deviceType })
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify(json.message, "success");
                    setUploadLoader(false)
                    eventTracker(CATEGORY, "CONTROLLER CREATED")
                    navigate.push('/parkingControllers')
                } else {
                    notify(json.message, "info");
                    setUploadLoader(false)
                }
            })
            .catch(e => {
                setUploadLoader(false)
                notify("Check your internet connection", "warning");
            });

    }

    const saveData = () => {
        fetch(`${config.HOST_NAME}/crm/v3/parkingControllers`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            },
            body: JSON.stringify({ device_id: settingJson.device_id, settings: settingJson.settings, description: settingJson.description, action_type: settingJson.action })
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify(json.message, "success");
                    setUploadLoader(false)
                    eventTracker(CATEGORY, "CONTROLLER CREATED")
                    navigate.push('/parkingControllers')
                } else {
                    notify(json.message, "info");
                    setUploadLoader(false)
                }
            })
            .catch(e => {
                setUploadLoader(false)
                notify("Check your internet connection", "warning");
            });
    }

    const saveEditorData = () => {
        try {
            // Attempt to parse the settingEditorJson string into JSON
            const settingJson = JSON.parse(settingEditorJson);
    
            // If parsing is successful, proceed with the API call
            fetch(`${config.HOST_NAME}/crm/v3/parkingControllers`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
                },
                body: JSON.stringify({ device_id: settingJson.device_id, settings: settingJson.settings, description: settingJson.description, action_type: settingJson.action })
            })
            .then(response => {
                saveTokens(response);
                return response.json();
            })
            .then(json => {
                if (json.success) {
                    notify(json.message, "success");
                    setUploadLoader(false);
                    eventTracker(CATEGORY, "CONTROLLER CREATED");
                    navigate.push('/parkingControllers');
                } else {
                    notify(json.message, "info");
                    setUploadLoader(false);
                }
            })
            .catch(e => {
                setUploadLoader(false);
                notify("Check your internet connection", "warning");
            });
        } catch (error) {
            // Handle the error when parsing JSON fails
            notify("Not a valid JSON:", "warning");
        }
    }
    

    const boomBarrierAddHandler = () => {
        setBoomBarries(boomBarriers => {
            const copy = [...boomBarriers]
            copy.push({ bluetooth_id: "", relay: "" })
            return copy
        })
    }

    const boomBarrierRemoveHandler = (index) => {
        setBoomBarries(boomBarriers => {
            const copy = [...boomBarriers]
            copy.splice(index, 1)
            return copy
        })
    }

    const readerAddHandler = () => {
        setReaders(boomBarriers => {
            const copy = [...boomBarriers]
            copy.push({ bluetooth_id: "", relay: "", log_type: "", manufacturer: "", model: "", reader_type: "", id: "", dev: "", gpio_0: "", gpio_1: "" })
            return copy
        })
    }

    const readerRemoveHandler = (index) => {
        setReaders(boomBarriers => {
            const copy = [...boomBarriers]
            copy.splice(index, 1)
            return copy
        })
    }

    const fetchParkings = () => {
        const token = sessionStorage.getItem('token');
        if (token != null && token !== "") {
            //setLoading(true);
            var params = {
                user_id: sessionStorage.getItem("user_id"),
                filter: JSON.stringify({ name: inputValue ? inputValue : undefined }),
                sort: JSON.stringify(["id", "ASC"]),
                page: 1,
                perPage: 10
            }
            fetch(`${config.HOST_NAME}/crm/v3/uniqueParkingAccessKeys?${stringify(params)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((responseJson) => {
                    //setLoading(false);
                    if (responseJson.success) {

                        let data = responseJson.data
                        let results = []
                        for (let val in data) {
                            results.push({ accessKey: data[val].access_key, name: data[val].name })
                        }
                        setOptions([...results])

                    } else {
                        notify(responseJson.message, 'warning');
                    }
                })
                .catch((e) => {
                    //setLoading(false);
                    notify('Error fetching data', 'warning');
                    console.log(e);
                });
        }
    };

    const handleEdit = (event) => {
        // const updatedData = JSON.parse(event.target.value);
        setSettingEditorJson(event.target.value);
       };

    React.useEffect(() => {
        fetchParkings()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue])

    React.useEffect(() => {
        setSettingEditorJson(JSON.stringify(templateJSON))
    }, [])
    


    return <>
    <div>
    <div style={{ display: "flex", alignItems: "center", columnGap: 10, marginTop: 20, fontSize: 14, boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)', border: "none" }}>
        <div onClick={() => setCurrentTab(SETTING)} style={{ borderBottom: currentTab === SETTING ? "solid 2px #334d6e" : "#FFF", color: currentTab === SETTING ? "#334d6e" : "#999", padding: "12px 25px", cursor: 'pointer', fontWeight: currentTab === SETTING ? 'bold' : 'normal' }}>
            SETTING
        </div>
        <div onClick={() => setCurrentTab(EDIT_SETTING)} style={{ borderBottom: currentTab === EDIT_SETTING ? "solid 2px #334d6e" : "#FFF", color: currentTab === EDIT_SETTING ? "#334d6e" : "#999", padding: "12px 25px", cursor: 'pointer', fontWeight: currentTab === EDIT_SETTING ? 'bold' : 'normal' }}>
            EDITOR
        </div>
        <div onClick={() => setCurrentTab(JSON_FILE)} style={{ borderBottom: currentTab === JSON_FILE ? "solid 2px #334d6e" : "#FFF", color: currentTab === JSON_FILE ? "#334d6e" : "#999", padding: "12px 25px", cursor: 'pointer', fontWeight: currentTab === JSON_FILE ? 'bold' : 'normal' }}>
             JSON FILE
        </div>
        {/*<div onClick={() => setCurrentTab(JSON_SETTING)} style={{ borderBottom: currentTab === JSON_SETTING ? "solid 2px #334d6e" : "#FFF", color: currentTab === JSON_SETTING ? "#334d6e" : "#999", padding: "12px 25px", cursor: 'pointer', fontWeight: currentTab === JSON_SETTING ? 'bold' : 'normal' }}>
            JSON SETTING
        </div>*/}
    </div>

        {currentTab === SETTING && 
            <Paper elevation={1} style={{ padding: "40px", marginTop: 10 }}>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 350px))", columnGap: 20, width: "100%", marginBottom: 20 }}>
                <Autocomplete
                    value={autovalue}
                    onChange={(event, newValue) => {
                        if (newValue) {
                            setAutoValue(newValue);
                            setAccessKey(newValue.accessKey)
                        }
                    }}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                    }}
                    id="controllable-states-demo"
                    size="small"
                    options={options}
                    getOptionLabel={option => option.name}
                    style={{ marginBottom: 20, width: 350 }}
                    renderInput={(params) => <TextField {...params} label="Parking Name" variant="outlined" />}
                />


                <CustomTextInput label="Device ID" getValue={deviceId} onChangeHandler={setDeviceId} />
                <CustomTextInput label="Description" getValue={controllerName} onChangeHandler={setControllerName} />
                <CustomTextInput label="Base API Url" getValue={baseApiUrl} onChangeHandler={setbaseApiUrl} />
                <TextField size="small" variant='outlined' label="Select Log Type" select value={action} onChange={actionHandler}>
                    <MenuItem value="ENTRY">ENTRY</MenuItem>
                    <MenuItem value="EXIT">EXIT</MenuItem>
                    <MenuItem value="BOTH">BOTH</MenuItem>
                </TextField>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 250px))", columnGap: 20, width: "100%", marginBottom: 20 }}>

                <CustomSwitch getValue={loopDaysEnable} onChangeHandler={setLoopDaysEnable} label="Close Loop Day" />
                <CustomSwitch getValue={ledPanelEnable} onChangeHandler={setLedPanelEnable} label="LED Panel" />
                <CustomSwitch getValue={ledBoardEnable} onChangeHandler={setLedBoardEnable} label="LED Board" />
                <CustomSwitch getValue={fastagEnable} onChangeHandler={setFastagEnable} label="FasTag Payment" />
                <CustomSwitch getValue={isAnprEnabled} onChangeHandler={setIsApnrEnabled} label="Is ANPR" />
                <CustomSwitch getValue={isNetworkLedEnabled} onChangeHandler={setIsNetworkLedEnabled} label="Is Network Led Enable" />
                <CustomSwitch getValue={isReaderLedEnabled} onChangeHandler={setIsReaderLedEnabled} label="Reader Led Enabled" />
                <CustomSwitch getValue={isProgramLedEnabled} onChangeHandler={setIsProgramLedEnabled} label="Program Led Enable" />
                <CustomSwitch getValue={isServerLedEnabled} onChangeHandler={setIsServerLedEnabled} label="Server Led Enable" />
                <CustomSwitch getValue={isBoomBarrierLedEnabled} onChangeHandler={setIsBoomBarrierLedEnabled} label="Boom Barrier Led Enable" />
                <CustomSwitch getValue={ledGpioOn} onChangeHandler={setLedGpioON} label="Led Gpio ON" />
                <CustomSwitch getValue={slottingEnable} onChangeHandler={setSlottingEnable} label="Slotting" />
                <CustomSwitch getValue={duplicateReaders} onChangeHandler={setDuplicateReaders} label="Duplicate Readers" />
                <CustomSwitch getValue={openEvenIfDuplicate} onChangeHandler={setOpenEvenIfDuplicate} label="Open Even If Duplicate" />

            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 350px))", columnGap: 20, width: "100%", marginBottom: 20 }}>
                <TextField size="small" variant='outlined' label="Database" select value={dataBase} onChange={(e) => setDatabase(e.target.value)}>
                    <MenuItem value="sqlite">sqlite</MenuItem>
                    <MenuItem value="postgresql">postgresql</MenuItem>
                </TextField>
                <CustomNumberInput label="Duplicate Timeout" getValue={duplicateTimeout} onChangeHandler={setDuplicateTimeout} />

                {
                    loopDaysEnable && <CustomNumberInput label="Loop Days" getValue={loopDays} onChangeHandler={setLoopDays} />
                }

                {
                    ledPanelEnable && <>
                        <CustomTextInput label="LED Panel Dev" getValue={ledPanelDev} onChangeHandler={setLedPanelDev} />
                        <CustomNumberInput label="LED Panel Row" getValue={ledPanelRows} onChangeHandler={setLedPanelRows} />
                    </>
                }

                {
                    ledBoardEnable &&
                    <>
                        <CustomTextInput label="LED Board Dev" getValue={ledBoardDev} onChangeHandler={setLedBoardDev} />
                        <CustomNumberInput label="LED Board Row" getValue={ledBoardRows} onChangeHandler={setLedBoardRows} />
                    </>
                }


                {
                    fastagEnable &&
                    <>
                        <CustomTextInput label="Fastag API URL" getValue={fastagApiUrl} onChangeHandler={setFastagApiUrl} />
                        <CustomTextInput label="Fastag Token" getValue={fastagToken} onChangeHandler={setFastagToken} />
                    </>
                }

                {
                    isAnprEnabled &&
                    <CustomTextInput label="ANPR ID" getValue={anprId} onChangeHandler={setAnprId} />
                }

                {
                    isNetworkLedEnabled &&
                    <CustomNumberInput label="Network Led Gpio" getValue={networkLedGpio} onChangeHandler={setNetworkLedGpio} />
                }

                {
                    isReaderLedEnabled &&
                    <CustomNumberInput label="Reader Led Gpio" getValue={readerLedGpio} onChangeHandler={setReaderLedGpio} />
                }

                {
                    isServerLedEnabled &&
                    <CustomNumberInput label="Server Led Gpio" getValue={serverLedGpio} onChangeHandler={setServerLedGpio} />
                }

            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 350px))", columnGap: 20, width: "100%", marginBottom: 20 }}>
                    <TextField
                        size="small"
                        variant='outlined'
                        label="Integrate With MyGate"
                        select
                        value={integrateWithMyGate}
                        onChange={(e) => setIntegrateWithMyGate(e.target.value)}

                    >
                        <MenuItem value="1">Enabled</MenuItem>
                        <MenuItem value="0">Disable</MenuItem>
                        <MenuItem value="2">Read Only</MenuItem>
                    </TextField>
                    <TextField
                        size="small"
                        variant='outlined'
                        label="Device Type"
                        select
                        value={deviceType}
                        onChange={(e) => setDeviceType(e.target.value)}

                    >
                        <MenuItem value=""></MenuItem>
                        <MenuItem value="PSTAG">ParkSmart Tag</MenuItem>
                        <MenuItem value="FASTAG">FASTag</MenuItem>
                        <MenuItem value="ANPR">ANPR</MenuItem>
                    </TextField>
                </div>

            <Tabs style={{ width: "100%", backgroundColor: "#18cc69", color: "#FFF" }} value={value} onChange={(event, newValue) => handleChange(event, newValue)}>
                <Tab label="Boom Barriers" value="boom_barriers" />
                <Tab label="Readers" value="readers" />
            </Tabs>

            {
                value === "boom_barriers" && <div style={{ display: "flex", justifyContent: "start", alignItems: "start", flexDirection: "column", paddingTop: "20px", marginBottom: "20px" }}>
                    <div style={{ display: "flex", justifyContent: boomBarriers.length === 0 ? "space-around" : "flex-end", alignItems: "center", width: "100%" }}>
                        {
                            boomBarriers.length === 0 && <Typography style={{ fontSize: "12px", color: "grey", marginBottom: "5px" }}>No Boom Barriers found!</Typography>
                        }

                        <Button variant='outlined' color='primary' size='small' onClick={boomBarrierAddHandler} startIcon={<AddIcon />} >Add</Button>

                    </div>

                    {
                        boomBarriers.map((val, index) => {

                            return (
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "95%", marginBottom: 20, backgroundColor: "#FAFAFA", padding: 20, borderRadius: 20, marginTop: 10 }}>
                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 250px))", gap: 20, width: "100%" }}>
                                        <TextField
                                            label="Bluetooth ID"
                                            defaultValue="Small"
                                            size="small"
                                            value={boomBarriers[index].bluetooth_id}
                                            onChange={(e) => setBoomBarries(boomBarriers => {
                                                const copy = [...boomBarriers]
                                                copy[index] = { ...copy[index], bluetooth_id: e.target.value }
                                                return copy
                                            })}
                                            variant='outlined'
                                        />
                                        <TextField
                                            label="Relay"
                                            defaultValue="Small"
                                            size="small"
                                            type="number"
                                            variant='outlined'
                                            value={boomBarriers[index].relay}
                                            onChange={(e) => setBoomBarries(boomBarriers => {
                                                const copy = [...boomBarriers]
                                                copy[index] = { ...copy[index], relay: e.target.value }
                                                return copy
                                            })}
                                            onBlur={(e) => setBoomBarries(boomBarriers => {
                                                const copy = [...boomBarriers]
                                                copy[index] = { ...copy[index], relay: isNaN(e.target.value) ? "" : Number(e.target.value) }
                                                return copy
                                            })}
                                        />
                                    </div>
                                    <IconButton onClick={() => boomBarrierRemoveHandler(index)}> <CloseIcon /></IconButton>
                                </div>
                            )
                        })
                    }
                </div>
            }
            {
                value === "readers" && <div style={{ display: "flex", justifyContent: "start", alignItems: "start", flexDirection: "column", paddingTop: "20px", marginBottom: "20px" }}>
                    <div style={{ display: "flex", justifyContent: readers.length === 0 ? "space-between" : "end", width: "100%" }}>
                        {
                            readers.length === 0 && <Typography style={{ fontSize: "12px", color: "grey", marginBottom: "5px" }}>No Readers found!</Typography>
                        }
                        <Button variant='outlined' color='primary' size='small' onClick={readerAddHandler} startIcon={<AddIcon />} >Add</Button>

                    </div>
                    {
                        readers.map((val, index) => {

                            let modelMenuItems = []
                            if (readers[index].manufacturer === "idtech") {
                                modelMenuItems = ["88", "87", "98"]
                            } if (readers[index].manufacturer === "timewatch") {
                                modelMenuItems = ["uhf12", "uhf12rg"]
                            } if (readers[index].manufacturer === "syrotech") {
                                modelMenuItems = ["fastag", "fastagL", "uhfL"]
                            } if (readers[index].manufacturer === "") {
                                modelMenuItems = ["kr600e"]
                            }

                            return (
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "95%", marginBottom: 20, backgroundColor: "#FAFAFA", padding: 20, borderRadius: 20, marginTop: 10 }}>

                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 250px))", gap: 20, width: "100%" }}>

                                        <TextField
                                            label="Reader Type"
                                            size="small"
                                            select
                                            value={readers[index].reader_type}
                                            onChange={(e) => setReaders(boomBarriers => {
                                                const copy = [...boomBarriers]
                                                copy[index] = { ...copy[index], reader_type: e.target.value }
                                                return copy
                                            })}
                                            variant='outlined'
                                        >
                                            <MenuItem value="UHF">UHF</MenuItem>
                                            <MenuItem value="LF">LF</MenuItem>
                                        </TextField>

                                        {
                                            readers[index].reader_type === "UHF" &&
                                            <TextField
                                                label="Dev"
                                                size="small"
                                                value={readers[index].dev}
                                                onChange={(e) => setReaders(boomBarriers => {
                                                    const copy = [...boomBarriers]
                                                    copy[index] = { ...copy[index], dev: e.target.value }
                                                    return copy
                                                })}
                                                variant='outlined'
                                            />
                                        }

                                        {
                                            readers[index].reader_type === "LF" &&
                                            <>
                                                <TextField
                                                    label="Gpio 0"
                                                    size="small"
                                                    type="number"
                                                    value={readers[index].gpio_0}
                                                    onChange={(e) => setReaders(boomBarriers => {
                                                        const copy = [...boomBarriers]
                                                        copy[index] = { ...copy[index], gpio_0: e.target.value }
                                                        return copy
                                                    })}
                                                    variant='outlined'
                                                    onBlur={(e) => setReaders(boomBarriers => {
                                                        const copy = [...boomBarriers]
                                                        copy[index] = { ...copy[index], gpio_0: isNaN(e.target.value) ? "" : Number(e.target.value) }
                                                        return copy
                                                    })}
                                                />
                                                <TextField
                                                    label="Gpio 1"
                                                    size="small"
                                                    type="number"
                                                    value={readers[index].gpio_1}
                                                    onChange={(e) => setReaders(boomBarriers => {
                                                        const copy = [...boomBarriers]
                                                        copy[index] = { ...copy[index], gpio_1: e.target.value }
                                                        return copy
                                                    })}
                                                    variant='outlined'
                                                    onBlur={(e) => setReaders(boomBarriers => {
                                                        const copy = [...boomBarriers]
                                                        copy[index] = { ...copy[index], gpio_1: isNaN(e.target.value) ? "" : Number(e.target.value) }
                                                        return copy
                                                    })}
                                                />
                                            </>
                                        }

                                        <TextField
                                            label="Manufacturer"
                                            size="small"
                                            select
                                            value={readers[index].manufacturer}
                                            onChange={(e) => setReaders(boomBarriers => {
                                                const copy = [...boomBarriers]
                                                copy[index] = { ...copy[index], manufacturer: e.target.value }
                                                return copy
                                            })}
                                            variant='outlined'
                                        >
                                            <MenuItem value="idtech">idtech</MenuItem>
                                            <MenuItem value="timewatch">timewatch</MenuItem>
                                            <MenuItem value="syrotech">syrotech</MenuItem>
                                            <MenuItem value=""></MenuItem>
                                        </TextField>

                                        <TextField
                                            label="Model"
                                            size="small"
                                            select
                                            value={readers[index].model}
                                            onChange={(e) => setReaders(boomBarriers => {
                                                const copy = [...boomBarriers]
                                                copy[index] = { ...copy[index], model: e.target.value }
                                                return copy
                                            })}
                                            variant='outlined'
                                        >
                                            {
                                                modelMenuItems.map((item) => <MenuItem value={item}>{item}</MenuItem>)
                                            }
                                        </TextField>

                                        <TextField
                                            size="small"
                                            variant='outlined'
                                            label="Log Type"
                                            select
                                            value={readers[index].log_type}
                                            onChange={(e) => setReaders(boomBarriers => {
                                                const copy = [...boomBarriers]
                                                copy[index] = { ...copy[index], log_type: e.target.value.length === 0 ? null : e.target.value }
                                                return copy
                                            })}
                                        >
                                            <MenuItem value="ENTRY">ENTRY</MenuItem>
                                            <MenuItem value="EXIT">EXIT</MenuItem>
                                            <MenuItem value="BOTH">BOTH</MenuItem>
                                        </TextField>

                                        <TextField
                                            label="ID"
                                            size="small"
                                            value={readers[index].id}
                                            onChange={(e) => setReaders(boomBarriers => {
                                                const copy = [...boomBarriers]
                                                copy[index] = { ...copy[index], id: e.target.value.length === 0 ? null : e.target.value }
                                                return copy
                                            })}
                                            variant='outlined'
                                        />

                                        <TextField
                                            label="Bluetooth ID"
                                            size="small"
                                            value={readers[index].bluetooth_id}
                                            onChange={(e) => setReaders(boomBarriers => {
                                                const copy = [...boomBarriers]
                                                copy[index] = { ...copy[index], bluetooth_id: e.target.value }
                                                return copy
                                            })}
                                            variant='outlined'
                                        />

                                        <TextField
                                            label="Relay"
                                            size="small"
                                            type="number"
                                            variant='outlined'
                                            value={readers[index].relay}
                                            onChange={(e) => setReaders(boomBarriers => {
                                                const copy = [...boomBarriers]
                                                copy[index] = { ...copy[index], relay: e.target.value }
                                                return copy
                                            })}

                                            onBlur={(e) => setReaders(boomBarriers => {
                                                const copy = [...boomBarriers]
                                                copy[index] = { ...copy[index], relay: isNaN(e.target.value) ? "" : Number(e.target.value) }
                                                return copy
                                            })}
                                        />
                                    </div>
                                    <IconButton onClick={() => readerRemoveHandler(index)}> <CloseIcon /></IconButton>
                                </div>
                            )
                        })
                    }
                </div>
            }



            <div style={{ width: "100%", backgroundColor: "#F5F5F5", padding: "20px", display: "flex", justifyContent: "end" }}>
                <Button variant='contained' color='primary' onClick={saveHandler} startIcon={<SaveIcon />} >Save {uploadLoader && <CircularProgress style={{ color: "#FFF", marginLeft: "10px" }} size={20} />}</Button>
            </div>
        </Paper>
        }

        {currentTab === JSON_SETTING && 
            <Paper elevation={1} style={{ padding: "15px", marginTop: 10 }}>
            <JSONInput
            id          = 'a_unique_id'
            value = { settingJson ? settingJson : {} }
            placeholder = { settingJson ? settingJson : {} }
            locale      = { locale }
            height      = '520px'
            width       = '100%'
            style={{fontSize : "10px"}}
            onChange={handleJsonChange}
            confirmGood={false}
            waitAfterKeyPress={5000}
            reset={false}
            onKeyPressUpdate={false}
        />
        <div style={{  padding: "20px", display: "flex", justifyContent: "end" }}>
            <Button variant='contained' color='primary' onClick={saveData} startIcon={<SaveIcon />} >Save {uploadLoader && <CircularProgress style={{ color: "#FFF", marginLeft: "10px" }} size={20} />}</Button>
        </div>
        </Paper>}

        {currentTab === EDIT_SETTING && 
            <Paper elevation={1} style={{ padding: "15px", marginTop: 10 }}>
            <textarea
            contenteditable
            rows="10"
            cols="50"
            value={settingEditorJson}
            onChange={handleEdit}
            style={{height: "480px", width: "100%"}}
          />
        <div style={{  padding: "20px", display: "flex", justifyContent: "end" }}>
            <Button variant='contained' color='primary' onClick={saveEditorData} startIcon={<SaveIcon />} >Save {uploadLoader && <CircularProgress style={{ color: "#FFF", marginLeft: "10px" }} size={20} />}</Button>
        </div>
        </Paper>}

        {currentTab === JSON_FILE && <CreateControllerWithJSONFile/>}
    </div>
    </>;
};

const CreateControllerWithJSONFile = () => {
    const eventTracker = UseAnalyticsEvent()
    const navigate = useHistory()
    const [uploadLoader, setUploadLoader] = useState(false)
    const [accessKey, setAccessKey] = useState("")
    const [deviceId, setDeviceId] = useState("")
    const [action, setAction] = useState("BOTH");
    const [options, setOptions] = useState([]);
    const [autovalue, setAutoValue] = React.useState("");
    const [inputValue, setInputValue] = React.useState('');
    const [selectedControllerSettings, setSelectedControllerSettings] = useState(null);

    const actionHandler = (event) => {
        setAction(event.target.value);
    };

    const saveHandler = () => {
        
        setUploadLoader(true)
        const formData = new FormData();
        formData.append('file', selectedControllerSettings);
        formData.append('device_id', deviceId);
        formData.append('access_key', accessKey);
        formData.append('action_type', action);
        formData.append('json_file', 1);

        fetch(`${config.HOST_NAME}/crm/v3/parkingControllers`, {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
            },
            body: formData
        })
            .then(response => {
                saveTokens(response)
                return response.json()
            })
            .then(json => {
                if (json.success) {
                    notify(json.message, "success");
                    setUploadLoader(false)
                    eventTracker(CATEGORY, "CONTROLLER CREATED")
                    navigate.push('/parkingControllers')
                } else {
                    notify(json.message, "warning");
                    setUploadLoader(false)
                }
            })
            .catch(e => {
                setUploadLoader(false)
                notify("Check your internet connection", "warning");
            });

    }

    const fetchParkings = () => {
        const token = sessionStorage.getItem('token');
        if (token != null && token !== "") {
            //setLoading(true);
            var params = {
                user_id: sessionStorage.getItem("user_id"),
                filter: JSON.stringify({ name: inputValue ? inputValue : undefined }),
                sort: JSON.stringify(["id", "ASC"]),
                page: 1,
                perPage: 10
            }
            fetch(`${config.HOST_NAME}/crm/v3/uniqueParkingAccessKeys?${stringify(params)}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                    'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
                },
            })
                .then(response => {
                    saveTokens(response)
                    return response.json()
                })
                .then((responseJson) => {
                    //setLoading(false);
                    if (responseJson.success) {

                        let data = responseJson.data
                        let results = []
                        for (let val in data) {
                            results.push({ accessKey: data[val].access_key, name: data[val].name })
                        }
                        setOptions([...results])

                    } else {
                        notify(responseJson.message, 'warning');
                    }
                })
                .catch((e) => {
                    //setLoading(false);
                    notify('Error fetching data', 'warning');
                    console.log(e);
                });
        }
    };

    const selectControllerSettingsHandler = (event) => {
        const file = event.target.files[0];
        if(file.type !== "application/json") return notify("Invalid File", "warning")
        setSelectedControllerSettings(file);
    }

    React.useEffect(() => {
        fetchParkings()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue])

    return <div>
            <Paper elevation={1} style={{ padding: "40px", marginTop: 10 }}>

                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 350px))", columnGap: 20, width: "100%", marginBottom: 20 }}>
                        <Autocomplete
                            value={autovalue}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    setAutoValue(newValue);
                                    setAccessKey(newValue.accessKey)
                                }
                            }}
                            inputValue={inputValue}
                            onInputChange={(event, newInputValue) => {
                                setInputValue(newInputValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={options}
                            getOptionLabel={option => option.name}
                            style={{ marginBottom: 20, width: 350 }}
                            renderInput={(params) => <TextField {...params} label="Parking Name" variant="outlined" />}
                        />
                        <CustomTextInput label="Device ID" getValue={deviceId} onChangeHandler={setDeviceId} />
                        <TextField size="small" variant='outlined' label="Select Log Type" select value={action} onChange={actionHandler}>
                            <MenuItem value="ENTRY">ENTRY</MenuItem>
                            <MenuItem value="EXIT">EXIT</MenuItem>
                            <MenuItem value="BOTH">BOTH</MenuItem>
                        </TextField>
                    </div>

                    <Button className='customCreateBtnStyle' title='Add' style={{marginBottom: 30}}>
                        <AddIcon style={{ fontSize: 22, marginRight: 10 }} />
                        {selectedControllerSettings && selectedControllerSettings.name ? selectedControllerSettings.name : "Upload Settings.json"}
                        <input type="file" accept=".json" onChange={selectControllerSettingsHandler} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", opacity: 0, cursor: "inherit" }} />
                    </Button>

                    <div style={{ width: "100%", backgroundColor: "#F5F5F5", padding: "20px", display: "flex", justifyContent: "end" }}>
                        <Button variant='contained' color='primary' onClick={saveHandler} startIcon={<SaveIcon />} >Save {uploadLoader && <CircularProgress style={{ color: "#FFF", marginLeft: "10px" }} size={20} />}</Button>
                    </div>
                </Paper>
            
        </div>
}

export default ControllerCreate;
